import { I18n } from '@calendly/i18n';
import { BareButton } from '@calendly/ui/components/bare-button';
import { MinimalButton } from '@calendly/ui/components/minimal-button';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { Container, SelectionControlsContainer, MenuContainer, List } from '../styles';
import { AllEventsTypes } from './utils';
const styledBareButtonCss = "s1iql2tc";
const StyledBareButton = forwardRef((props, ref) => <BareButton ref={ref} {...props} className={classNames(styledBareButtonCss, props.className)} />);
const UnstyledMenuActionItem = ({
  show,
  ...restProps
}) => show ? <li><div {...restProps} /></li> : null;
const menuActionItemCss = "m1c5qpgl";
const MenuActionItem = forwardRef((props, ref) => <UnstyledMenuActionItem ref={ref} {...props} className={classNames(menuActionItemCss, props.className)} />);
const styledMenuActionItemCss = "s19fcejy";
const StyledMenuActionItem = forwardRef((props, ref) => <MenuActionItem ref={ref} {...props} className={classNames(styledMenuActionItemCss, props.className)} />);
const ShowMoreGroups = ({
  onClick,
  show = true
}) => <StyledMenuActionItem show={show}>
    <StyledBareButton onClick={onClick}>
      {I18n.t('publisher.meeting_intelligence.dropdown.select_event_types.show_more')}
    </StyledBareButton>
  </StyledMenuActionItem>;
export const ContentBody = ({
  eventTypes,
  onChange,
  handleSelectAll,
  handleClearAll,
  handleFetchMoreEvents
}) => <Container>
    <SelectionControlsContainer>
      <MinimalButton fontSize="small" onClick={() => handleSelectAll()}>
        {I18n.t('publisher.meeting_intelligence.dropdown.select_event_types.select_all')}
      </MinimalButton>
      <MinimalButton fontSize="small" onClick={() => handleClearAll()}>
        {I18n.t('publisher.meeting_intelligence.dropdown.select_event_types.clear_all')}
      </MinimalButton>
    </SelectionControlsContainer>
    <MenuContainer>
      {eventTypes.map(eventType => <List key={eventType.id}>
            <AllEventsTypes eventTypeId={eventType.id} name={eventType.name} eventTypes={eventType.items} onChange={onChange} />
            <ShowMoreGroups onClick={() => handleFetchMoreEvents(eventType)} show={eventType?.showButton} />
          </List>)}
    </MenuContainer>
  </Container>;

require("./content_body.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./content_body.js");